export default "__VITE_ASSET__DL61f$eo__"